import { createContext } from "react";
const Chartcontext = createContext();
export default Chartcontext;
